import { WebSocketEntityUpdateInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { store } from '@/redux/store';
import { ENTITY_OPERATION_TYPES } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.constants';
import { MapInstance } from '@/types/map';
import { getOverlayGroup } from '@/redux/overlayGroup/overlayGroup.thunks';
import { deleteOverlayGroup } from '@/redux/overlayGroup/overlayGroup.slice';

export default async function processDataOverlayGroup({
  data,
}: {
  data: WebSocketEntityUpdateInterface;
  mapInstance: MapInstance;
}): Promise<void> {
  const { dispatch } = store;
  if (
    data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED ||
    data.type === ENTITY_OPERATION_TYPES.ENTITY_UPDATED
  ) {
    dispatch(
      getOverlayGroup({
        groupId: data.entityId,
      }),
    );
  } else if (data.type === ENTITY_OPERATION_TYPES.ENTITY_DELETED) {
    dispatch(
      deleteOverlayGroup({
        groupId: data.entityId,
      }),
    );
  }
}
